/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Gray_Thick_Stoat_SeekInputs */

const en_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We couldn't find a purchase associated with your email address.`);
	return /** @type {LocalizedString} */ (`We couldn't find a subscription associated with your email address.`)
	
};

const id_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami tidak dapat menemukan pembelian yang terkait dengan alamat email Anda.`);
	return /** @type {LocalizedString} */ (`Kami tidak dapat menemukan langganan yang terkait dengan alamat email Anda.`)
	
};

const ms_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami tidak dapat mencari pembelian yang dikaitkan dengan alamat e-mel anda.`);
	return /** @type {LocalizedString} */ (`Kami tidak menemui langganan yang dikaitkan dengan alamat e-mel anda.`)
	
};

const ca_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`No hem pogut trobar cap compra associada a la teva adreça electrònica.`);
	return /** @type {LocalizedString} */ (`No hem pogut trobar una subscripció associada a la teva adreça de correu electrònic.`)
	
};

const cs_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nepodařilo se nám najít nákup spojený s vaší e-mailovou adresou.`);
	return /** @type {LocalizedString} */ (`Nepodařilo se nám najít předplatné propojené s vaší e-mailovou adresou.`)
	
};

const da_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunne ikke finde et køb tilknyttet din e-mailadresse.`);
	return /** @type {LocalizedString} */ (`Vi kunne ikke finde et abonnement tilknyttet din e-mailadresse.`)
	
};

const de_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Wir konnten keinen Kauf finden, der mit Ihrer E-Mail-Adresse verknüpft ist.`);
	return /** @type {LocalizedString} */ (`Wir konnten kein Abonnement finden, das mit Ihrer E-Mail-Adresse verbunden ist.`)
	
};

const et_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Me ei leidnud sinu e-posti aadressiga seotud ostu.`);
	return /** @type {LocalizedString} */ (`Me ei leidnud teie e-posti aadressiga seotud tellimust.`)
	
};

const es_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`No pudimos encontrar una compra asociada a tu dirección de correo electrónico.`);
	return /** @type {LocalizedString} */ (`No pudimos encontrar una suscripción asociada con tu correo electrónico.`)
	
};

const fr_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nous n’avons trouvé aucun achat associé à votre adresse e-mail.`);
	return /** @type {LocalizedString} */ (`Nous n’avons pas trouvé d’abonnement associé à votre adresse e-mail.`)
	
};

const hr_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nismo mogli pronaći kupnju povezanu s vašom email adresom.`);
	return /** @type {LocalizedString} */ (`Nismo mogli pronaći pretplatu povezanu s vašom e-mail adresom.`)
	
};

const it_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Non abbiamo trovato un acquisto associato al tuo indirizzo email.`);
	return /** @type {LocalizedString} */ (`Non abbiamo trovato alcun abbonamento associato al tuo indirizzo email.`)
	
};

const lv_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mēs nevarējām atrast pirkumu, kas saistīts ar jūsu e-pasta adresi.`);
	return /** @type {LocalizedString} */ (`Jūsu e-pasta adresei nav piesaistīts neviens abonements.`)
	
};

const lt_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nepavyko rasti pirkinio, susieto su jūsų el. pašto adresu.`);
	return /** @type {LocalizedString} */ (`Nėra jokių prenumeratų, susijusių su jūsų el. pašto adresu.`)
	
};

const hu_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nem találtunk az e-mail-címedhez társított vásárlást.`);
	return /** @type {LocalizedString} */ (`Nem találtunk az e-mail címéhez kapcsolódó előfizetést.`)
	
};

const nl_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We konden geen aankoop vinden die is gekoppeld aan je e-mailadres.`);
	return /** @type {LocalizedString} */ (`We konden geen abonnement vinden dat is gekoppeld aan je e-mailadres.`)
	
};

const nb_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunne ikke finne et kjøp knyttet til e-postadressen din.`);
	return /** @type {LocalizedString} */ (`Vi fant ingen abonnementer som er knyttet til e-postadressen din.`)
	
};

const pl_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nie znaleźliśmy zakupu powiązanego z Twoim adresem e-mail.`);
	return /** @type {LocalizedString} */ (`Nie mogliśmy znaleźć subskrypcji powiązanej z Twoim adresem e-mail.`)
	
};

const pt_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Não encontramos uma compra associada ao seu endereço de e-mail.`);
	return /** @type {LocalizedString} */ (`Não encontramos uma assinatura associada ao seu endereço de e-mail.`)
	
};

const ro_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nu am putut găsi o achiziție asociată cu adresa ta de email.`);
	return /** @type {LocalizedString} */ (`Nu am putut găsi un abonament asociat cu adresa ta de e-mail.`)
	
};

const sk_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nenašli sme nákup spojený s vašou e-mailovou adresou.`);
	return /** @type {LocalizedString} */ (`Nepodarilo sa nám nájsť predplatné priradené k vašej emailovej adrese.`)
	
};

const sl_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nismo našli nakupa, povezanega z vašim e-poštnim naslovom.`);
	return /** @type {LocalizedString} */ (`Nismo našli naročnine, povezane z vašim e-naslovom.`)
	
};

const fi_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Emme löytäneet sähköpostiosoitteeseesi liitettyä ostosta.`);
	return /** @type {LocalizedString} */ (`Emme löytäneet sähköpostiosoitteeseesi liittyvää tilausta.`)
	
};

const sv_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi kunde inte hitta något köp kopplat till din e-postadress.`);
	return /** @type {LocalizedString} */ (`Vi kunde inte hitta en prenumeration som är kopplad till din e-postadress.`)
	
};

const vi_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Chúng tôi không tìm thấy mua hàng nào được liên kết với địa chỉ email của bạn.`);
	return /** @type {LocalizedString} */ (`Chúng tôi không thể tìm thấy gói đăng ký nào liên kết với địa chỉ email của bạn.`)
	
};

const tr_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`E-posta adresinizle ilişkili bir satın alma bulamadık.`);
	return /** @type {LocalizedString} */ (`E-posta adresinizle ilişkili bir abonelik bulamadık.`)
	
};

const el_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Δεν μπορέσαμε να βρούμε αγορά συσχετισμένη με τη διεύθυνση email σας.`);
	return /** @type {LocalizedString} */ (`Δεν μπορέσαμε να βρούμε μια συνδρομή που να σχετίζεται με τη διεύθυνση email σας.`)
	
};

const bg_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Не успяхме да намерим покупка, свързана с вашия имейл адрес.`);
	return /** @type {LocalizedString} */ (`Не успяхме да намерим абонамент, свързан с твоя имейл адрес.`)
	
};

const ru_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Мы не нашли покупки, связанной с вашим адресом электронной почты.`);
	return /** @type {LocalizedString} */ (`Мы не смогли найти подписку, связанную с вашим адресом электронной почты.`)
	
};

const sr_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Нисмо могли да пронађемо куповину повезану са вашом адресом е-поште.`);
	return /** @type {LocalizedString} */ (`Нисмо успели да пронађемо претплату повезану са вашом имејл адресом.`)
	
};

const uk_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ми не знайшли покупки, пов'язаної з вашою електронною адресою.`);
	return /** @type {LocalizedString} */ (`Ми не змогли знайти підписку, пов'язану з вашою електронною адресою.`)
	
};

const ka_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`ჩვენ ვერ ვიპოვეთ თქვენს ელფოსტის მისამართთან დაკავშირებული შეძენა.`);
	return /** @type {LocalizedString} */ (`თქვენი ელფოსტის მისამართთან დაკავშირებული გამოწერა ვერ ვიპოვეთ.`)
	
};

const hi_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`हमें आपके ईमेल पते से जुड़ी कोई खरीद नहीं मिली।`);
	return /** @type {LocalizedString} */ (`हमें आपके ईमेल एड्रेस से सम्बंधित कोई सब्सक्रिप्शन नहीं मिल सका।`)
	
};

const th_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เราไม่พบการซื้อที่เชื่อมโยงกับที่อยู่อีเมลของคุณ`);
	return /** @type {LocalizedString} */ (`เราไม่พบการสมัครสมาชิกที่เชื่อมโยงกับที่อยู่อีเมลของคุณ`)
	
};

const ko_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`귀하의 이메일 주소와 연결된 구매를 찾을 수 없습니다.`);
	return /** @type {LocalizedString} */ (`회원님의 이메일 주소와 연결된 구독을 찾을 수 없습니다.`)
	
};

const zh_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们无法找到与您的电子邮件地址关联的订阅。`)
};

const zh_tw_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`我們找不到與您的電子郵件地址相關聯的購買。`);
	return /** @type {LocalizedString} */ (`我們無法找到與您的電子郵件地址相關的訂閱服務。`)
	
};

const ja_gray_thick_stoat_seek = /** @type {(inputs: Gray_Thick_Stoat_SeekInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`お客様のメールアドレスに関連付けられている購入が見つかりませんでした。`);
	return /** @type {LocalizedString} */ (`あなたのメールアドレスに関連付けられているサブスクリプションが見つかりませんでした。`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "We couldn't find a purchase associated with your email address." |
* | * | "We couldn't find a subscription associated with your email address." |
*
* @param {Gray_Thick_Stoat_SeekInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const gray_thick_stoat_seek = /** @type {((inputs: Gray_Thick_Stoat_SeekInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Thick_Stoat_SeekInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gray_thick_stoat_seek(inputs)
	if (locale === "ms") return ms_gray_thick_stoat_seek(inputs)
	if (locale === "ca") return ca_gray_thick_stoat_seek(inputs)
	if (locale === "cs") return cs_gray_thick_stoat_seek(inputs)
	if (locale === "da") return da_gray_thick_stoat_seek(inputs)
	if (locale === "de") return de_gray_thick_stoat_seek(inputs)
	if (locale === "et") return et_gray_thick_stoat_seek(inputs)
	if (locale === "es") return es_gray_thick_stoat_seek(inputs)
	if (locale === "fr") return fr_gray_thick_stoat_seek(inputs)
	if (locale === "hr") return hr_gray_thick_stoat_seek(inputs)
	if (locale === "it") return it_gray_thick_stoat_seek(inputs)
	if (locale === "lv") return lv_gray_thick_stoat_seek(inputs)
	if (locale === "lt") return lt_gray_thick_stoat_seek(inputs)
	if (locale === "hu") return hu_gray_thick_stoat_seek(inputs)
	if (locale === "nl") return nl_gray_thick_stoat_seek(inputs)
	if (locale === "nb") return nb_gray_thick_stoat_seek(inputs)
	if (locale === "pl") return pl_gray_thick_stoat_seek(inputs)
	if (locale === "pt") return pt_gray_thick_stoat_seek(inputs)
	if (locale === "ro") return ro_gray_thick_stoat_seek(inputs)
	if (locale === "sk") return sk_gray_thick_stoat_seek(inputs)
	if (locale === "sl") return sl_gray_thick_stoat_seek(inputs)
	if (locale === "fi") return fi_gray_thick_stoat_seek(inputs)
	if (locale === "sv") return sv_gray_thick_stoat_seek(inputs)
	if (locale === "vi") return vi_gray_thick_stoat_seek(inputs)
	if (locale === "tr") return tr_gray_thick_stoat_seek(inputs)
	if (locale === "el") return el_gray_thick_stoat_seek(inputs)
	if (locale === "bg") return bg_gray_thick_stoat_seek(inputs)
	if (locale === "ru") return ru_gray_thick_stoat_seek(inputs)
	if (locale === "sr") return sr_gray_thick_stoat_seek(inputs)
	if (locale === "uk") return uk_gray_thick_stoat_seek(inputs)
	if (locale === "ka") return ka_gray_thick_stoat_seek(inputs)
	if (locale === "hi") return hi_gray_thick_stoat_seek(inputs)
	if (locale === "th") return th_gray_thick_stoat_seek(inputs)
	if (locale === "ko") return ko_gray_thick_stoat_seek(inputs)
	if (locale === "zh") return zh_gray_thick_stoat_seek(inputs)
	if (locale === "zh-tw") return zh_tw_gray_thick_stoat_seek(inputs)
	if (locale === "ja") return ja_gray_thick_stoat_seek(inputs)
	return en_gray_thick_stoat_seek(inputs)
});